import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import DetailsIcon from '@/CustomIcons/DetailsIcon'
import { Card, cardXPad } from '../../Card'
import { CardHeader } from '../../CardHeader'
import useRoomActions from '@/services/useRoomActions'
import { useRoomContext } from '@/RoomContext'
import { Field } from '../../Field'
import { UnlockWithPro } from '@/components/UnlockWithPro'
import { DateTime, Duration } from 'luxon'
import { useUserContext } from '@/UserContext'

export function InformationSection() {
    const [roomState] = useRoomContext()
    const { upgradeToSfuRoom } = useRoomActions()

    return (
        <Card className="flex flex-col gap-[40px] px-0 md:px-0">
            <CardHeader icon={DetailsIcon} title="Session Information" className={cardXPad} />
            <div className="flex flex-col gap-[26px]">
                <SessionDurationField />
                <Field title="Current Participant Count">{Object.keys(roomState.peers).length + 1}</Field>
                <Field title="Session Network Type">
                    <div onDoubleClick={upgradeToSfuRoom}>{roomState.expectedNetworkTopology}</div>
                </Field>
            </div>
        </Card>
    )
}

function SessionDurationField() {
    const { t } = useTranslation()
    const [userState] = useUserContext()
    const [roomState] = useRoomContext()
    const [sessionDuration, setSessionDuration] = useState('')

    const maxMinutes = userState.profile?.policy?.roomTierPolicy.sessionDurationLimitMins
    const maxMinutesDisplay = Duration.fromObject({ minutes: maxMinutes }).toFormat('hh:mm:ss')

    const calculateDuration = () => {
        const startedTime = roomState.sessionStartedTime
        if (startedTime) {
            const diff_s = DateTime.now().diff(DateTime.fromJSDate(startedTime), 'seconds').seconds
            return Duration.fromObject({ seconds: diff_s }).toFormat('hh:mm:ss')
        } else {
            return '00:00:00'
        }
    }

    useEffect(() => {
        const timer: NodeJS.Timer = setInterval(
            (function timer() {
                const duration: string = calculateDuration()
                setSessionDuration(duration)
                return timer
            })(),
            1000
        )

        return () => {
            clearInterval(timer)
        }
    }, [])

    return (
        <Field title="Session Duration">
            <div className="tabular-nums inline-flex items-center gap-1">
                <span>{sessionDuration}</span> / <span className="font-light opacity-75">{maxMinutesDisplay}</span>{' '}
                <UnlockWithPro className="inline pl-6" />
            </div>
        </Field>
    )
}
